import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, Fragment, useRef } from 'react';
import apiRequest from '../../functions/api';
import { Typography, TextField, Box, Button, ButtonGroup, Grid, Paper, MenuItem, Table, TableContainer, TableBody, TableRow, TableCell, List, ListItem, ListItemButton } from "@mui/material";
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import Page from "../shared/components/PageComponent";
import DynamicTable from "../shared/components/DynamicTableComponent";
import { FullPageSpinner } from "../lib";
function MasterStamm(props) {
  const { t } = useTranslation();
  const { accessToken, client, pvxprogramm, buttonClick, stamm, setStamm, auswahl, setAuswahl, ansichtstatus, setAnsichtstatus, minbreite, tablesuche, fenstergroße, keineAktionen, StartFilter, zeilenklickbar, textsuchvorgabe } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [filter, setFilter] = useState(StartFilter ? StartFilter : "");
  const [suche, setze_suche] = useState("");
  const breite = minbreite ? minbreite : 500
  const search = tablesuche ? tablesuche : "GESAMT"
  const smgroße = fenstergroße ? fenstergroße : 12
  const zeichne_aktionen = keineAktionen ? false : true
  const [zweiterbutton, setZweiterbutton] = useState("");
  useEffect(() => {
    init()
    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    setFilter(StartFilter);
    // eslint-disable-next-line
  }, [ansichtstatus])

  const InitCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.stamm) {
        setStamm(response.data.stamm)
      }
      if (response.data.zweiterbutton) {
        setZweiterbutton(response.data.zweiterbutton)
      }
      if (response.data.stamm?.menufilterinit) {
        setFilter(response.data.stamm.menufilterinit)
      }
      if (response.data.ansichtstatus) {
        setAnsichtstatus(response.data.ansichtstatus)
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const init = () => {
    setIsLoading(true);
    const payload = {
      "mandant": client,
      "program": pvxprogramm,
      "statement": "INIT",
      "ansichtstatus": ansichtstatus,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, InitCb);
  }
  const fitlerByType = (element) => {
    var result;
    result = true
    if (filter !== "") {
      if (filter !== element.filter) { result = false }
    }
    if (!element.bez.toLowerCase().includes(suche.toLowerCase())) { result = false }
    return (result);
  }
  const AuswahlAndern = (e, element) => {
    if (stamm?.tabelle?.scrollto) {
      document.getElementById(stamm?.tabelle?.scrollto)?.scrollIntoView();
    }
    setAuswahl(element.key)
  }
  const zeichne_links = () => {
    if (stamm?.menu?.filter(element => fitlerByType(element)).length > 0) {
      return (
        stamm?.menu.filter(element => fitlerByType(element)).map((element) => {
          return (
            <ListItemButton divider selected={element.key === auswahl} onClick={(e) => AuswahlAndern(e, element)} key={element.key}>
              {element.bez}
            </ListItemButton>
          )
        })
      )
    } else {
      return (
        <ListItem key="none">
          {t("keine Menupunkte vorhanden")}
        </ListItem>
      )
}
  }
const zeichne_rechts = () => {
  if (stamm?.aktionen && auswahl) {
    if (stamm?.aktionen[auswahl]) {
      return (
        <ButtonGroup orientation="vertical" fullWidth>
          {
            stamm?.aktionen[auswahl].map((element) => {
              return (
                <Box p={0.5}>
                  <Button variant="contained" fullWidth onClick={() => buttonClick(element.key, auswahl,)} color="primary" >{element.bez}</Button>
                </Box>
              )
            })
          }
        </ButtonGroup>
      )
    } else {
      <Fragment></Fragment>
    }
  } else {
    return (
      <Fragment></Fragment>
    )
  }
}
const setze_filter = (value) => {
  setFilter(value);
  setAuswahl("");
}
const zeichne_filter = () => {
  if (stamm) {
    if (stamm?.menufilter?.length > 0 || stamm?.auswertung || stamm?.wechseln) {
      return (
        <Fragment>
          <Grid item xs={zeichne_aktionen ? 3 : 2}>
            <Box p={1}>
              {stamm?.menufilter?.length > 0 &&
                <TextField
                  select
                  variant="outlined"
                  label={t("Filter")}
                  value={filter}
                  onChange={(event) => setze_filter(event.target.value)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  {stamm?.menufilter?.map((filters) => {
                    return (
                      <MenuItem value={filters.key}>{filters.bez}</MenuItem>
                    )
                  })
                  }
                </TextField>
              }
            </Box>
          </Grid>
          {!zweiterbutton &&
            <Grid item xs={zeichne_aktionen ? 7 : 8}>
              <Box p={1}>
                {stamm?.wechseln &&
                  <Button fullWidth variant="contained" color="primary" onClick={() => buttonClick("WECHSELN", stamm?.wechseln,)} >{stamm?.wechseln_text}</Button>
                }
              </Box>
            </Grid>
          }
          {zweiterbutton &&
            <Fragment>
              <Grid item xs={zeichne_aktionen ? 5 : 6}>
                <Box p={1}>
                  {stamm?.wechseln &&
                    <Button fullWidth variant="contained" color="primary" onClick={() => buttonClick("WECHSELN", stamm?.wechseln,)} >{stamm?.wechseln_text}</Button>
                  }
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Box p={1}>
                  <Button fullWidth variant="contained" color="primary" onClick={() => buttonClick("ZUSATZ")} >{zweiterbutton}</Button>
                </Box>
              </Grid>
            </Fragment>
          }

          <Grid item xs={2}>
            <Box p={1}>
              {stamm?.auswertung &&
                <Button fullWidth variant="contained" color="primary" onClick={() => buttonClick("AUSWERTUNG", "",)} >{stamm?.auswertungstext ? stamm?.auswertungstext : "Auswertungen"}</Button>
              }
            </Box>
          </Grid>
        </Fragment>
      )
    }
  }
}
const zeichne_tabelle = () => {
  var zeilen = stamm?.tabelle?.[auswahl]
  return (
    <DynamicTable zeilenklickbar={zeilenklickbar} textsuchvorgabe={textsuchvorgabe} zeilen={zeilen} spalten={stamm?.[auswahl]?.tabelle?.ueber ? stamm?.[auswahl]?.tabelle?.ueber : stamm?.tabelle?.ueber} options={options} leertext={" "} hoehe={"95%"} buttonCb={(spaltenkey, zeilenkey) => buttonClick(spaltenkey, zeilenkey,)} minbreite={breite} size={"small"} ladevariable={auswahl} suche={search} />
  )
}
const zeichne_neuanlage = () => {
  if (stamm) {
    if (stamm?.neuanlage) {
      return (
        <Fragment>
          <Grid item xs={zeichne_aktionen ? 12 : 2}>
            <Box p={1}>
              <Button variant="contained" fullWidth color="primary" onClick={() => buttonClick("NEUANLAGE", "",)} > {stamm?.anlagetext ? stamm?.anlagetext : "Neuanlage"}  </Button>
            </Box>
          </Grid>
          <Grid item xs={zeichne_aktionen ? 7 : 10}>
            <Fragment></Fragment>
          </Grid>
          <Grid item xs={2}>
            <Fragment></Fragment>
          </Grid>
        </Fragment>
      )
    }
  }
}

const zeichne_serienbrief = () => {
  if (stamm) {
    if (stamm?.serienbrief) {
      return (
        <Fragment>
          <Grid item xs={zeichne_aktionen ? 12 : 2}>
            <Box p={1}>
              <Button variant="contained" fullWidth color="primary" onClick={() => buttonClick("SERIENBRIEF", "",)} > {stamm?.anlage2text ? stamm?.anlage2text : "serienbrief"}  </Button>
            </Box>
          </Grid>
          <Grid item xs={zeichne_aktionen ? 7 : 10}>
            <Fragment></Fragment>
          </Grid>
          <Grid item xs={2}>
            <Fragment></Fragment>
          </Grid>
        </Fragment>
      )
    }
  }
}
return (
  <Page  >
    <Grid container justifyContent="center">
      <Grid item xs={12} sm={smgroße} key="maingrid">
        <Box p={1}>
          <Grid container spacing={2} justifyContent="center">
            {zeichne_filter()}
            <Grid item xs={zeichne_aktionen ? 3 : 2} key="aktion">
              <Box p={1} >
                <Paper style={{ height: "80vh", width: "100%", display: "flex", flexDirection: "column" }} >
                  <TextField
                    variant="outlined"
                    label={t("Suche")}
                    value={suche}
                    onChange={(event) => setze_suche(event.target.value)}
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >
                  </TextField>
                  <List>
                    {zeichne_links()}
                  </List>
                  {/* <TableContainer style={{ width: "100%", overflow: "auto", flexGrow: 1 }} >
                      <Table>
                        <TableBody>
                          {zeichne_links()}
                        </TableBody>
                      </Table>
                    </TableContainer> */}
                  <Box>
                    {zeichne_neuanlage()}
                    {zeichne_serienbrief()}
                  </Box>
                </Paper>
              </Box>
            </Grid>
            <Grid item xs={zeichne_aktionen ? 7 : 10} key="tabelle">
              <Box p={1}>
                <Paper style={{ height: "80vh", width: "100%" }}>
                  {zeichne_tabelle()}
                </Paper>
              </Box>
            </Grid>
            {zeichne_aktionen &&
              <Grid item xs={2} key="details">
                <Box p={1}>
                  <Paper style={{ height: "80vh", width: "100%" }}>
                    {auswahl !== "" &&
                      <Fragment>
                        {zeichne_rechts()}
                      </Fragment>
                    }
                  </Paper>
                </Box>
              </Grid>
            }
          </Grid>
        </Box>
      </Grid>
    </Grid>
    {isLoading &&
      <FullPageSpinner />
    }

  </Page>
)
}
export default MasterStamm;
